import React from 'react';
import { InboundOrOutboundOrdersList } from 'components/inbound-outbound-orders';

export function OutboundOrders() {
  return <InboundOrOutboundOrdersList pageTitle="Outbound Orders" />;
}
